(function () {
var FREE_SHIPPING_THRESHOLD = 300000; // 3000 EGP in cents
var NEW_INS_CACHE = null;
var CART_CACHE = null;
var UPSELL_CACHE = null;
var PRODUCT_PRICE_CACHE = {};
var LAST_SHIPPING_PROGRESS = 0;

  function drawer() { return document.getElementById('df-cart-drawer'); }
  function overlay() { return document.getElementById('df-cart-overlay'); }
  function body() { return document.getElementById('df-cart-body'); }
  function count() { return document.getElementById('df-cart-count'); }

  function openDeframeCart() {
    var d = drawer();
    var o = overlay();
    if (!d || !o) return;

    d.classList.add('is-open');
    o.classList.add('is-active');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('df-cart-open');

    renderCart();
    window.dfSyncCartIconBubble();
  }

  function closeDeframeCart() {
  var d = drawer();
  var o = overlay();
  if (!d || !o) return;

  d.classList.remove('is-open');
  o.classList.remove('is-active');
  d.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('df-cart-open');

  window.dfSyncCartIconBubble();

  window.setTimeout(function () {
    window.dfSyncCartIconBubble();
  }, 250);
}

  function renderCart() {
    var b = body();
    if (!b) return;

    if (CART_CACHE && CART_CACHE.df_enriched === true) {
  buildCart(CART_CACHE);
}

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
  return enrichCartPrices(cart);
})
.then(function (cart) {
  cart.df_enriched = true;
  CART_CACHE = cart;
  buildCart(cart);
})
      .catch(function () {
        if (!CART_CACHE) {
          b.innerHTML = '<p class="df-cart__error">Could not load cart.</p>';
        }
      });
  }

  function formatCartLinePrice(item) {
  var price = item.final_price;
  var compareAt = item.df_compare_at_price || 0;
  var quantity = item.quantity || 1;

  if (compareAt > price) {
    return (
      '<span class="df-price--compare">' + formatMoney(compareAt * quantity) + '</span>' +
      '<span class="df-price--sale">' + formatMoney(price * quantity) + '</span>'
    );
  }

  return formatMoney(price * quantity);
}

function enrichCartPrices(cart) {
  if (!cart || !cart.items || !cart.items.length) {
    return Promise.resolve(cart);
  }

  return Promise.all(cart.items.map(function (item) {
    if (!item.handle || !item.variant_id) return Promise.resolve();

    if (PRODUCT_PRICE_CACHE[item.handle]) {
      applyComparePrice(item, PRODUCT_PRICE_CACHE[item.handle]);
      return Promise.resolve();
    }

    return fetch('/products/' + item.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        PRODUCT_PRICE_CACHE[item.handle] = product;
        applyComparePrice(item, product);
      })
      .catch(function () {});
  })).then(function () {
    return cart;
  });
}

function applyComparePrice(item, product) {
  if (!product || !product.variants) return;

  var variant = product.variants.find(function (v) {
    return Number(v.id) === Number(item.variant_id);
  });

  if (!variant) return;

  item.df_compare_at_price = variant.compare_at_price || 0;
}

  function buildCart(cart) {
    var b = body();
    var c = count();
    var ff = document.getElementById('df-cart-fixed-footer');
    var ft = document.getElementById('df-cart-footer-total');
    if (!b) return;

    if (c) c.textContent = cart.item_count;

    if (cart.item_count === 0) {
      if (ff) ff.style.display = 'none';

      var nextHtml = [
        '<div class="df-cart__empty-shell">',
        '  <div class="df-cart__empty">',
        '    <div class="df-cart__empty-content">',
'      <p class="df-cart__empty-text">START BUILDING YOUR BAG</p>',
'      <a href="/collections/frame-02" class="df-cart__empty-cta">SHOP NEW ARRIVALS</a>',
'    </div>',
        '  </div>',
        '  <div class="df-cart__new-arrivals">',
        '    <div class="df-cart__new-arrivals-header">',
        '      <div class="df-cart__new-arrivals-left">',
        '        <span>Best Sellers</span>',
        '        <button class="df-cart__carousel-btn df-cart__carousel-prev" type="button" aria-label="Previous">‹</button>',
        '        <button class="df-cart__carousel-btn df-cart__carousel-next" type="button" aria-label="Next">›</button>',
        '      </div>',
        '      <a href="/collections/best-sellers">VIEW ALL</a>',
        '    </div>',
        '    <div class="df-cart__carousel" id="df-cart-new-arrivals-carousel">',
        '      <div class="df-cart__carousel-track" id="df-cart-new-arrivals-grid"></div>',
        '    </div>',
        '  </div>',
        '</div>'
      ].join('');

b.innerHTML = nextHtml;

if (ff) {
  ff.style.display = 'none';
}

requestAnimationFrame(function () {
  b.classList.add('is-empty-ready');
  loadNewInsProducts();
});

return;
    }
    var subtotal = cart.items_subtotal_price;

var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
var progress = Math.min(100, (subtotal / FREE_SHIPPING_THRESHOLD) * 100);
var shippingText = remaining > 0
  ? 'You are <strong>' + formatMoney(remaining) + '</strong> away from free shipping'
  : "You've unlocked free shipping!";

var shippingHtml = [
  '<div class="df-cart__shipping">',
  '  <div class="df-cart__shipping-bar">',
  '    <div class="df-cart__shipping-fill" data-progress="' + progress + '"></div>',
  '  </div>',
  '  <p class="df-cart__shipping-text">' + shippingText + '</p>',
  '</div>'
].join('');

var itemsHtml = cart.items.map(function (item) {
  var imgSrc = item.image
    ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_300x$1$2')
    : '';

  var variantLabel = item.variant_title && item.variant_title !== 'Default Title'
    ? item.variant_title
    : '';

  return [
        '<div class="df-cart-item" data-key="' + item.key + '" data-url="' + item.url + '">',
        imgSrc ? '<img src="' + imgSrc + '" alt="' + escHtml(item.product_title) + '">' : '',
        '<div class="df-cart-item__info">',
        '  <p class="df-cart-item__title">' + escHtml(item.product_title) + '</p>',
        variantLabel ? '  <p class="df-cart-item__meta">' + escHtml(variantLabel) + '</p>' : '',
        '  <p class="df-cart-item__price">' + formatCartLinePrice(item) + '</p>',
        '  <div class="df-cart-item__qty">',
        '    <button class="df-qty-btn df-qty-minus" data-key="' + item.key + '" aria-label="Decrease">−</button>',
        '    <span class="df-qty-num">' + item.quantity + '</span>',
        '    <button class="df-qty-btn df-qty-plus" data-key="' + item.key + '" aria-label="Increase">+</button>',
        '    <button class="df-remove-btn" data-key="' + item.key + '" aria-label="Remove">',
        '      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor">',
        '        <path d="M2 4h12"/>',
        '        <path d="M6 4V2h4v2"/>',
        '        <rect x="3" y="4" width="10" height="10" rx="1"/>',
        '      </svg>',
        '    </button>',
        '  </div>',
        '</div>',
        '</div>'
      ].join('');
    }).join('');

    var upsellHtml = [
      '<div class="df-cart__upsell">',
      '  <div class="df-cart__upsell-header">',
      '    <div class="df-cart__upsell-left">',
      '      <span>LAST MINUTE ADDITIONS</span>',
      '    </div>',
      '    <div class="df-cart__upsell-arrows">',
      '      <button class="df-cart__upsell-prev" type="button" aria-label="Previous">‹</button>',
      '      <button class="df-cart__upsell-next" type="button" aria-label="Next">›</button>',
      '    </div>',
      '  </div>',
      '  <div class="df-cart__upsell-carousel" id="df-cart-upsell-carousel">',
      '    <div class="df-cart__upsell-track" id="df-cart-upsell-track"></div>',
      '  </div>',
      '</div>'
    ].join('');

    if (ff) ff.style.display = 'block';
    if (ft) ft.textContent = formatMoney(cart.items_subtotal_price);

    b.innerHTML =
  '<div class="df-cart__filled-shell">' +
    shippingHtml +
    '<div class="df-cart__items">' + itemsHtml + '</div>' +
    upsellHtml +
  '</div>';

requestAnimationFrame(function () {
  var bar = document.querySelector('.df-cart__shipping-fill');
  if (!bar) return;

  var target = Number(bar.getAttribute('data-progress')) || 0;

  bar.style.width = LAST_SHIPPING_PROGRESS + '%';

  requestAnimationFrame(function () {
    bar.style.width = target + '%';
    LAST_SHIPPING_PROGRESS = target;
  });
});

loadUpsellProducts();
  }
function swapCartBody(html, callback) {
  var b = body();
  if (!b) return;

  b.classList.add('is-updating');

  window.setTimeout(function () {
    b.innerHTML = html;

    requestAnimationFrame(function () {
      b.classList.remove('is-updating');

      if (typeof callback === 'function') callback();
    });
  }, 120);
}

function flyUpsellImageToCart(sourceImg) {
  return new Promise(function (resolve) {
    if (!sourceImg) {
      resolve();
      return;
    }

    var target = document.getElementById('df-cart-count');
    if (!target) {
      resolve();
      return;
    }

    var imgRect = sourceImg.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();

    var clone = sourceImg.cloneNode(true);

    clone.className = 'df-fly-img';
    clone.style.position = 'fixed';
    clone.style.top = imgRect.top + 'px';
    clone.style.left = imgRect.left + 'px';
    clone.style.width = imgRect.width + 'px';
    clone.style.height = imgRect.height + 'px';
    clone.style.zIndex = '9999';
    clone.style.pointerEvents = 'none';
    clone.style.objectFit = 'cover';
    clone.style.opacity = '0.72';
    clone.style.filter = 'blur(0px)';
    clone.style.transform = 'translate3d(0,0,0) scale(1)';
    clone.style.transformOrigin = 'center center';

    document.body.appendChild(clone);

    var endX = targetRect.left + targetRect.width / 2 - imgRect.width * 0.18;
    var endY = targetRect.top + targetRect.height / 2 - imgRect.height * 0.18;

    requestAnimationFrame(function () {
      clone.style.transition =
        'top 520ms cubic-bezier(0.22, 1, 0.36, 1), ' +
        'left 520ms cubic-bezier(0.22, 1, 0.36, 1), ' +
        'width 520ms cubic-bezier(0.22, 1, 0.36, 1), ' +
        'height 520ms cubic-bezier(0.22, 1, 0.36, 1), ' +
        'opacity 420ms ease, ' +
        'filter 420ms ease';

      clone.style.top = endY + 'px';
      clone.style.left = endX + 'px';
      clone.style.width = imgRect.width * 0.36 + 'px';
      clone.style.height = imgRect.height * 0.36 + 'px';
      clone.style.opacity = '0';
      clone.style.filter = 'blur(1px)';
    });

    setTimeout(function () {
      if (clone && clone.parentNode) clone.remove();
      resolve();
    }, 540);
  });
}

  function updateQuantity(key, newQty, animateKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart update failed');
        return r.json();
      })
      .then(function (cart) {
  return enrichCartPrices(cart);
})
.then(function (cart) {

  cart.df_enriched = true;
  CART_CACHE = cart;

  if (cart.item_count === 0) {
    window.setTimeout(function () {
      buildCart(cart);
    }, 260);
  } else {
    buildCart(cart);
  }

if (animateKey) {
  requestAnimationFrame(function () {
    var changedItem = document.querySelector('.df-cart-item[data-key="' + animateKey + '"]');
    var qtyNum = changedItem ? changedItem.querySelector('.df-qty-num') : null;
    var itemPrice = changedItem ? changedItem.querySelector('.df-cart-item__price') : null;
    var footerTotal = document.getElementById('df-cart-footer-total');

    [qtyNum, itemPrice, footerTotal].forEach(function (el) {
      if (!el) return;

      el.classList.add('is-changing');

      setTimeout(function () {
        el.classList.remove('is-changing');
      }, 160);
    });
  });
}

window.dfSyncCartIconBubble();
      })
      .catch(function (err) {
        console.error('[df-cart] update error:', err);
      });
  }

  function initEmptyCartCarousel() {
  var carousel = document.getElementById('df-cart-new-arrivals-carousel');
  var prev = document.querySelector('.df-cart__carousel-prev');
  var next = document.querySelector('.df-cart__carousel-next');

  if (!carousel || !prev || !next) return;
  if (carousel.dataset.initialized === 'true') return;

  carousel.dataset.initialized = 'true';

  function updateArrows() {
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    var scrollLeft = carousel.scrollLeft;

    prev.classList.toggle('is-disabled', scrollLeft <= 4);
    next.classList.toggle('is-disabled', scrollLeft >= maxScroll - 4);
  }

  prev.addEventListener('click', function () {
    carousel.scrollBy({
      left: -carousel.clientWidth,
      behavior: 'smooth'
    });
  });

  next.addEventListener('click', function () {
    carousel.scrollBy({
      left: carousel.clientWidth,
      behavior: 'smooth'
    });
  });

  carousel.addEventListener('scroll', updateArrows, {
    passive: true
  });

  updateArrows();
}

  function loadNewInsProducts() {
    var grid = document.getElementById('df-cart-new-arrivals-grid');
    if (!grid) return;

    function renderProducts(products) {
      grid.innerHTML = products.map(function (p) {
        var img = p.images && p.images[0]
          ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/, '_500x$1$2')
          : '';

        return [
          '<a href="/products/' + p.handle + '" class="df-cart__new-arrivals-item">',
          img ? '<img src="' + img + '" alt="' + escHtml(p.title) + '">' : '',
          '</a>'
        ].join('');
      }).join('');

      initEmptyCartCarousel();
    }

    if (NEW_INS_CACHE) {
      renderProducts(NEW_INS_CACHE);
      return;
    }

    fetch('/collections/best-sellers/products.json?limit=12')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        NEW_INS_CACHE = data.products || [];
        renderProducts(NEW_INS_CACHE);
      })
      .catch(function () {
        grid.innerHTML = '';
      });
  }

  function preloadUpsell() {
    fetch('/collections/last-minute-additions/products.json?limit=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        UPSELL_CACHE = data.products || [];
      })
      .catch(function () {});
  }

  function formatUpsellPrice(product) {
  var variant = product.variants && product.variants[0];
  if (!variant) return '';

  var price = Number(variant.price) * 100;
  var compareAt = variant.compare_at_price ? Number(variant.compare_at_price) * 100 : 0;

  if (compareAt > price) {
    return (
      '<span class="df-price--compare">' + formatMoney(compareAt) + '</span>' +
      '<span class="df-price--sale">' + formatMoney(price) + '</span>'
    );
  }

  return formatMoney(price);
}

  function loadUpsellProducts() {
    var track = document.getElementById('df-cart-upsell-track');
    if (!track) return;

    function renderUpsells(products) {
      track.innerHTML = products.map(function (p) {
        var img = p.images && p.images[0] && p.images[0].src
          ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/, '_500x$1$2')
          : '';

        if (!p.variants || !p.variants.length) return '';

        return [
          '<div class="df-cart__upsell-item">',
          img ? '<img src="' + img + '" alt="' + escHtml(p.title) + '">' : '',
          '  <div class="df-cart__upsell-info">',
          '    <p class="df-cart__upsell-title">' + escHtml(p.title) + '</p>',
          '    <p class="df-cart__upsell-price">' + formatUpsellPrice(p) + '</p>',
          '    <div class="df-upsell-actions">',
          '      <div class="df-upsell-select-wrap">',
          '        <select class="df-upsell-size-select">',
          '          <option value="">Size</option>',
          p.variants.map(function (v) {
            var disabled = v.available ? '' : ' disabled';
            return '<option value="' + v.id + '"' + disabled + '>' + escHtml(v.title) + '</option>';
          }).join(''),
          '        </select>',
          '      </div>',
          '      <button class="df-upsell-add" type="button" disabled>ADD</button>',
          '    </div>',
          '  </div>',
          '</div>'
        ].join('');
      }).join('');

      initUpsellCarousel();
    }

    if (UPSELL_CACHE) {
      renderUpsells(UPSELL_CACHE);
      return;
    }

    fetch('/collections/last-minute-additions/products.json?limit=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        UPSELL_CACHE = data.products || [];
        renderUpsells(UPSELL_CACHE);
      })
      .catch(function (err) {
        console.error('[df-cart] upsell load error:', err);
      });
  }

  function initUpsellCarousel() {
    var carousel = document.getElementById('df-cart-upsell-carousel');
    var track = document.getElementById('df-cart-upsell-track');
    var prev = document.querySelector('.df-cart__upsell-prev');
    var next = document.querySelector('.df-cart__upsell-next');

    if (!carousel || !track || !prev || !next) return;
    if (carousel.dataset.initialized === 'true') return;

    var realItems = Array.from(track.children);
    var realCount = realItems.length;

    if (realCount <= 1) return;

    carousel.dataset.initialized = 'true';

    var firstClone = realItems[0].cloneNode(true);
    var lastClone = realItems[realCount - 1].cloneNode(true);

    firstClone.classList.add('df-upsell-clone');
    lastClone.classList.add('df-upsell-clone');

    track.insertBefore(lastClone, realItems[0]);
    track.appendChild(firstClone);

    var index = 1;
    var autoplay = null;
    var resumeTimer = null;
    var settleTimer = null;
    var ignoreScroll = false;
    var hovering = false;

    function width() {
      return carousel.clientWidth || 1;
    }

    function jumpTo(i) {
      ignoreScroll = true;
      carousel.style.scrollBehavior = 'auto';
      carousel.scrollLeft = i * width();

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          carousel.style.scrollBehavior = '';
          ignoreScroll = false;
        });
      });
    }

    function smoothTo(i) {
      carousel.scrollTo({
        left: i * width(),
        behavior: 'smooth'
      });
    }

    function getIndex() {
      return Math.round(carousel.scrollLeft / width());
    }

    function normalizeIfClone() {
      var i = getIndex();

      if (i === 0) {
        index = realCount;
        jumpTo(index);
        return;
      }

      if (i === realCount + 1) {
        index = 1;
        jumpTo(index);
        return;
      }

      index = i;
    }

    function stopAutoplay() {
      if (autoplay) {
        clearInterval(autoplay);
        autoplay = null;
      }

      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      autoplay = setInterval(function () {
        smoothTo(getIndex() + 1);

        window.setTimeout(function () {
          normalizeIfClone();
        }, 520);
      }, 3000);
    }

    function resumeAutoplay() {
      if (hovering) return;

      if (resumeTimer) clearTimeout(resumeTimer);

      resumeTimer = setTimeout(function () {
        startAutoplay();
      }, 1200);
    }

    function handleUserScrollEnd() {
      stopAutoplay();

      if (settleTimer) clearTimeout(settleTimer);

      settleTimer = setTimeout(function () {
        normalizeIfClone();
        resumeAutoplay();
      }, 180);
    }

    carousel.addEventListener('scroll', function () {
      if (ignoreScroll) return;
      handleUserScrollEnd();
    }, { passive: true });

    carousel.addEventListener('touchstart', function () {
      stopAutoplay();
    }, { passive: true });

    carousel.addEventListener('touchend', function () {
      handleUserScrollEnd();
    }, { passive: true });

    carousel.addEventListener('mouseenter', function () {
      hovering = true;
      stopAutoplay();
    });

    carousel.addEventListener('mouseleave', function () {
      hovering = false;
      resumeAutoplay();
    });

    next.addEventListener('click', function () {
      stopAutoplay();
      smoothTo(getIndex() + 1);

      window.setTimeout(function () {
        normalizeIfClone();
        resumeAutoplay();
      }, 520);
    });

    prev.addEventListener('click', function () {
      stopAutoplay();
      smoothTo(getIndex() - 1);

      window.setTimeout(function () {
        normalizeIfClone();
        resumeAutoplay();
      }, 520);
    });

    window.addEventListener('resize', function () {
      jumpTo(index);
    });

    jumpTo(index);
    startAutoplay();
  }

  window.dfSyncCartIconBubble = async function () {
  try {
    var cart = await fetch('/cart.js', {
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (res) {
      return res.json();
    });

    CART_CACHE = cart;

    var itemCount = cart.item_count || 0;

    document.dispatchEvent(new CustomEvent('cart:update', {
  bubbles: true,
  detail: {
    cart: cart,
    data: {
      itemCount: itemCount,
      cartItemCount: itemCount,
      source: 'deframe-cart-sync'
    }
  }
}));

document.dispatchEvent(new CustomEvent('theme:cart:update', {
  bubbles: true,
  detail: {
    cart: cart,
    itemCount: itemCount
  }
}));

    document.querySelectorAll('cart-icon').forEach(function (cartIcon) {
      var bubble =
        cartIcon.querySelector('[ref="cartBubble"]') ||
        cartIcon.querySelector('.cart-count-bubble');

      var countEl =
        cartIcon.querySelector('[ref="cartBubbleCount"]') ||
        cartIcon.querySelector('.cart-count-bubble span');

      if (countEl) {
        countEl.textContent = itemCount;
        countEl.classList.toggle('hidden', itemCount === 0);
      }

      if (bubble) {
        bubble.classList.toggle('visually-hidden', itemCount === 0);
      }

      cartIcon.classList.toggle(
        'header-actions__cart-icon--has-cart',
        itemCount > 0
      );
    });

    document.querySelectorAll(
  '#df-cart-count, [data-cart-count]'
).forEach(function (el) {
  el.textContent = itemCount;
});

document.querySelectorAll('a, button, cart-icon, .header-actions__cart-icon').forEach(function (el) {
  var text = (el.textContent || '').trim();

  if (/^BAG\s*\(\d+\)$/i.test(text)) {
    el.textContent = 'BAG (' + itemCount + ')';
  }
});

    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(itemCount),
        timestamp: Date.now()
      })
    );

    var c = count();
    if (c) c.textContent = itemCount;

  } catch (err) {
    console.error('Failed to sync cart icon bubble:', err);
  }
};

    (function () {
    if (window.dfCartHistorySyncBound) return;
    window.dfCartHistorySyncBound = true;

    var syncTimer = null;
    var lastSyncAt = 0;

    function syncCartAfterRestore() {
      if (typeof window.dfSyncCartIconBubble !== 'function') return;

      var now = Date.now();

      if (now - lastSyncAt < 700) return;

      clearTimeout(syncTimer);

      syncTimer = window.setTimeout(function () {
        lastSyncAt = Date.now();
        window.dfSyncCartIconBubble();
      }, 120);
    }

    window.addEventListener('pageshow', function () {
      syncCartAfterRestore();
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        syncCartAfterRestore();
      }
    });

    window.addEventListener('focus', function () {
      syncCartAfterRestore();
    });
  })();

  document.addEventListener('click', function (e) {
    if (e.target.closest('#df-cart-close')) {
      closeDeframeCart();
      return;
    }

    if (e.target === overlay()) {
      closeDeframeCart();
      return;
    }

    var minusBtn = e.target.closest('.df-qty-minus');
if (minusBtn) {
  var item = minusBtn.closest('.df-cart-item');
  var current = item ? parseInt(item.querySelector('.df-qty-num').textContent, 10) : 1;

  if (current <= 1) {
    if (item) {
      item.classList.add('is-removing');

      window.setTimeout(function () {
        updateQuantity(minusBtn.dataset.key, 0);
      }, 300);
    } else {
      updateQuantity(minusBtn.dataset.key, 0);
    }

    return;
  }

  updateQuantity(minusBtn.dataset.key, current - 1, minusBtn.dataset.key);
  return;
}

var plusBtn = e.target.closest('.df-qty-plus');
if (plusBtn) {
  var key = plusBtn.dataset.key;

  var item = CART_CACHE && CART_CACHE.items
    ? CART_CACHE.items.find(function (i) {
        return i.key === key;
      })
    : null;

  if (!item) return;

  updateQuantity(key, item.quantity + 1, key);
  return;
}

var removeBtn = e.target.closest('.df-remove-btn');
if (removeBtn) {
  e.preventDefault();
  e.stopPropagation();

  var removeItem = removeBtn.closest('.df-cart-item');
  var removeKey = removeBtn.dataset.key;

  if (!removeItem || !removeKey) return;

  removeItem.classList.add('is-removing');

  window.setTimeout(function () {
    updateQuantity(removeKey, 0);
  }, 300);

  return;
}

    var upsellBtn = e.target.closest('.df-upsell-add');
if (upsellBtn) {
  if (upsellBtn.disabled) return;

  var variantId = upsellBtn.dataset.variantId;
  if (!variantId) return;

  upsellBtn.disabled = true;
upsellBtn.textContent = 'ADDED';

var upsellItem = upsellBtn.closest('.df-cart__upsell-item');
var upsellImg = upsellItem ? upsellItem.querySelector('img') : null;

var flyDone = flyUpsellImageToCart(upsellImg);

fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    id: Number(variantId),
    quantity: 1
  })
})
  .then(function (r) {
    if (!r.ok) throw new Error('Add failed');
    return r.json();
  })
  .then(function () {
    return flyDone;
  })
  .then(function () {
    renderCart();
    window.dfSyncCartIconBubble();
  })
  .catch(function (err) {
    upsellBtn.disabled = false;
    upsellBtn.textContent = 'ADD';
    console.error('[df-cart] upsell add error:', err);
  });
  return;
}

var cartItemMedia = e.target.closest('.df-cart-item > img');
var cartItemTitle = e.target.closest('.df-cart-item__title');

if (cartItemMedia || cartItemTitle) {
  var cartItem = e.target.closest('.df-cart-item');
  var url = cartItem ? cartItem.dataset.url : '';

  if (url) {
    window.location.assign(url);
  }

  return;
}

    var cartLink = e.target.closest('a[href="/cart"], a[href="/cart/"], cart-icon, .header-actions__cart-icon');
    if (cartLink) {
      e.preventDefault();
      openDeframeCart();
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('.df-upsell-size-select');
    if (!select) return;

    var parent = select.closest('.df-cart__upsell-item');
    var addBtn = parent && parent.querySelector('.df-upsell-add');

    if (!addBtn) return;

    if (select.value) {
      addBtn.dataset.variantId = select.value;
      addBtn.disabled = false;
    } else {
      addBtn.disabled = true;
      addBtn.removeAttribute('data-variant-id');
    }
  });

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
  return 'LE ' + (cents / 100).toLocaleString('en-EG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function preloadCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      return enrichCartPrices(cart);
    })
    .then(function (cart) {
      cart.df_enriched = true;
      CART_CACHE = cart;

      var c = count();
      if (c) c.textContent = cart.item_count;

      window.dfSyncCartIconBubble();
    })
    .catch(function (err) {
      console.error('[df-cart] preload error:', err);
    });
}

window.openDeframeCart = openDeframeCart;
window.closeDeframeCart = closeDeframeCart;
window.preloadDeframeCart = preloadCart;

preloadUpsell();
preloadCart();
})();